<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div v-if="eventType" class="h-100 display-flex flex-column">
		<FormSwitchRow
			class="el-switch-always-on"
			inactive-text="Use general availability"
			active-text="Use custom availability"
			v-model="eventType.isAvailabilityLocal"
			@change="onAvailabilityLocalChanged"
		></FormSwitchRow>

		<div class="card p-4 h-100 my-3">


			<AvailabilityGrid
				v-if="eventType.isAvailabilityLocal"
				:availability="eventType.availabilitySettings"
				@onChange="onAvailabilitySettingsChanged">
			</AvailabilityGrid>
			<div v-else class="row text-center align-items-center justify-content-center mx-0" style="flex-grow: 1">
				<div>
					<div>Availability for this session type will be taken from your general availability.</div>
					<div>To change the availability, you can adjust your
						<router-link :to="{name: this.schedulerGeneralAvailabilityRoute}">general availability</router-link>
						or enable custom availability for this session type above.
					</div>
				</div>


			</div>
		</div>

	</div>
</template>
<style>

</style>

<script>


import BaseComponent from "@/core/components/BaseComponent.vue";
import AvailabilityGrid from "@/core/modules/coach/Scheduler/Availability/AvailabilityGrid.vue";
import FormSwitchRow from "@/core/components/Form/FormSwitchRow.vue";
import EventType from "@shared/scheduler/EventType";

export default {
	name: "EventTypeAvailabilitySettingsView",
	components: {FormSwitchRow, AvailabilityGrid},
	extends: BaseComponent,
	props: {
		eventType: EventType,
		schedulerGeneralAvailabilityRoute: String,
	},

	data() {
		return {};
	},

	created() {
		if(!this.eventType.availabilitySettings){
			this.eventType.availabilitySettings = this.userProfile.schedulerSettings.availabilitySettings
		}
	},

	methods: {

		async onAvailabilityLocalChanged() {
			let res = await this.handleAsync(this.$dataManager.setEventType(this.eventType), "Saving...")
			if (res) {
				this.toast("Availability saved")
			}
		},

		async onAvailabilitySettingsChanged(availabilitySettings) {
			this.eventType.availabilitySettings = availabilitySettings
			let res = await this.handleAsync(this.$dataManager.setEventType(this.eventType), "Saving...")
			if (res) {
				this.toast("Availability saved")
			}
		},


	},
	computed: {}


}
</script>

<style src="../../Scheduler.scss" lang="scss" scoped/>


<style scoped>
.section-margin {
	margin-bottom: 6rem
}

.label-width {
	width: 140px !important;
}
</style>
